module.exports = __webpack_public_path__ + "static/media/logo-open.b591af56.jpg";